module.exports = __webpack_public_path__ + "static/media/ics.4216993c.png";